import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const ActivityIcon: React.FC<SvgProps> = ({ width = 24, height = 24, color, ...props }) => {
  const { theme } = useTheme()
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M22 12H18L15 21L9 3L6 12H2"
        stroke={color ?? theme.iconSecondary}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default React.memo(ActivityIcon)
